import { EXTERNAL_URLS } from '../../constants/urls';

export const footerLinks = [
  {
    title: 'Documentation',
    links: [
      {
        text: 'Introduction to AirKey',
        url: EXTERNAL_URLS.INTRODUCTION_TO_AIRKEY,
      },
      { text: 'AirKey Applet', url: EXTERNAL_URLS.AIRKEY_APPLET },
      { text: 'Card Registration', url: EXTERNAL_URLS.CARD_REGISTRATION },
      { text: 'AirKey SDK', url: EXTERNAL_URLS.AIRKEY_SDK },
      { text: 'Switchboard', url: EXTERNAL_URLS.SWITCHBOARD },
      { text: 'Validator', url: EXTERNAL_URLS.VALIDATOR },
    ],
  },
  { title: 'Downloads', links: [{ text: 'Artifacts', url: '/' }] },
  {
    title: 'Sandbox',
    links: [
      {
        text: 'Bank App Login with AirKey as Second Factor',
        url: EXTERNAL_URLS.SANDBOX_BANK_APP_LOGIN,
      },
      {
        text: 'Zelle Transfer with AirKey as Second Factor',
        url: EXTERNAL_URLS.SANDBOX_ZELLE_TRANSFER,
      },
      {
        text: '3DS Transaction Approval with AirKey Authentication',
        url: EXTERNAL_URLS.SANDBOX_3DS,
      },
      {
        text: 'Online Account Setup with AirKey as Second Factor',
        url: EXTERNAL_URLS.SANDBOX_ACCOUNT_SETUP,
      },
      { text: 'Build your own', url: EXTERNAL_URLS.SANDBOX_BUILD_YOUR_OWN },
    ],
  },
];
